import { MouseEvent,useState } from 'react';
import { IconButton, TextFieldProps } from '@mui/material';

import { VisibilityOffIcon } from '../../icons/VisibilityOff';
import { VisibilityOnIcon } from '../../icons/VisibilityOn';
import { Root } from '../input/input.styles';

import { InputAdornmentWrapper } from './styles';

export const DriverPasswordInput = ({ ...props }: TextFieldProps) => {
	const [isRevealed, setIsRevealed] = useState<boolean>(false);

	const handleClickRevealPassword = () => {
		setIsRevealed(!isRevealed);
	};

	const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
	};

	return (
		<Root
			{...props}
			type={isRevealed ? 'text' : 'password'}
			variant="filled"
			color="primary"
			InputProps={{
				disableUnderline: true,
				endAdornment: (
					<InputAdornmentWrapper error={props.error} position="end">
						<IconButton
							data-testid="PasswordInput-togglePasswordVisibility-button"
							aria-label="toggle password visibility"
							onClick={handleClickRevealPassword}
							onMouseDown={handleMouseDownPassword}
							edge="end"
						>
							{isRevealed ? <VisibilityOnIcon /> : <VisibilityOffIcon />}
						</IconButton>
					</InputAdornmentWrapper>
				),
			}}
		/>
	);
};
